var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-slot"},[(_vm.loaded)?[_vm._t("default",function(){return [_c('img',{attrs:{"src":_vm.image}})]},null,{image: _vm.image})]:_vm._e(),(!_vm.loaded)?_c('v-progress-circular',{staticClass:"mt-15",attrs:{"size":60,"indeterminate":"","color":"primary"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }